import { APP_VERSION } from '@/config/appVersion';

export const MOBILE_APP_VERSION = APP_VERSION;

export const ANDROID_PACKAGE =
  import.meta.env.VITE_ANDROID_PACKAGE || 'com.vyora.app';

export const DEEP_LINK_SCHEME =
  import.meta.env.VITE_DEEP_LINK_SCHEME || 'societyapp';

export const WHATSAPP_DEFAULT_COUNTRY =
  import.meta.env.VITE_WHATSAPP_DEFAULT_COUNTRY || '91';

export const BOTTOM_NAV_HEIGHT = 64;

export const OFFLINE_QUEUE_KEY = 'society-offline-queue';
export const OFFLINE_CACHE_PREFIX = 'society-offline-cache:';

export const COMMITTEE_ROLES = [
  'SUPER_ADMIN',
  'PRESIDENT',
  'VICE_PRESIDENT',
  'GENERAL_SECRETARY',
  'JOINT_SECRETARY',
  'TREASURER',
  'EXECUTIVE_MEMBER',
  'AUDITOR',
  'COMMITTEE_MEMBER',
] as const;

export const COMING_SOON_ROUTES = {
  meetings: '/meetings',
  dues: '/dues',
  visitors: '/visitors',
  gallery: '/gallery',
  expenses: '/expenses',
  elections: '/elections',
  collections: '/collections',
} as const;
